import clsx from 'clsx';
import React, {
    useEffect,
    useState
} from 'react';
import {
    useLocation,
    useNavigate
} from 'react-router-dom';

import Icon from '@common/components/Icon';
import Logo from '@common/components/Logo';
import styles from './Sidebar.module.scss';
import WorkspaceSwitcher from './WorkspaceSwitcher';

interface SidebarMenuItem {
    name: string;
    path?: string;
    onClick?: () => void;
    icon: React.ReactNode;
    end?: boolean;
}

interface SidebarProps {
    menuItems?: SidebarMenuItem[];
    bottomItems?: SidebarMenuItem[];
    forceCollapsed?: boolean;
}

const SidebarItem = ({
    icon: IconNode, label, active, onClick, collapsed, rightSlot
}: any) => {
    return (
        <div
            onClick={onClick}
            className={clsx(
                styles.sidebarItem,
                collapsed && styles.collapsed,
                active && styles.active,
                "group"
            )}
        >
            {typeof IconNode === 'string' ? (
                <img src={IconNode} alt={label} />
            ) : (
                IconNode
            )}
            {!collapsed && <span>{label}</span>}
            {!collapsed && rightSlot}

            {collapsed ? (
                <div className={styles.tooltip}>
                    {label}
                </div>
            ) : null}
        </div>
    );
};

import UserMenu from '../UserMenu/UserMenu';

const Sidebar: React.FC<SidebarProps> = ({
    menuItems, bottomItems, forceCollapsed
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isHoverLogo, setIsHoverLogo] = useState(false);

    useEffect(() => {
        if (forceCollapsed) setIsSidebarCollapsed(true);
    }, [forceCollapsed]);

    const isPulseActive = location.pathname.startsWith('/pulse');

    return (
        <div className={clsx(styles.sidebar, isSidebarCollapsed && styles.collapsed)}>
            <div
                className={styles.logoSection}
                onMouseEnter={() => setIsHoverLogo(true)}
                onMouseLeave={() => setIsHoverLogo(false)}
            >
                <div
                    style={{
                        display: (isSidebarCollapsed && isHoverLogo) ? 'none' : 'flex',
                        height: 40,
                        paddingLeft: isSidebarCollapsed ? 0 : 16,
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Logo size={isSidebarCollapsed ? "32px" : "24px"} hideText={isSidebarCollapsed} />
                </div>
                <button
                    style={{display: (!isSidebarCollapsed || isHoverLogo) ? 'flex' : 'none'}}
                    className={styles.toggleButton}
                    onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                >
                    <Icon tips={!isSidebarCollapsed ? 'Collapse sidebar' : 'Expand sidebar'} side="right" name={'collapse'} />
                </button>
            </div>

            <div className="px-3 py-2 mb-2 shrink-0">
                <WorkspaceSwitcher collapsed={isSidebarCollapsed} />
            </div>

            <div className={styles.scrollArea}>
                {/* <div className={styles.separator} /> */}
                <SidebarItem
                    icon={<Icon name="layout" tips="Dashboard" size={20} side="right" />}
                    label="Dashboard"
                    active={location.pathname === '/'}
                    onClick={() => navigate('/')}
                    collapsed={isSidebarCollapsed}
                />
                <SidebarItem
                    icon={<Icon name="pulse" tips="Pulse" size={20} side="right" />}
                    label="Pulse"
                    active={isPulseActive}
                    onClick={() => navigate('/pulse')}
                    collapsed={isSidebarCollapsed}
                />
            </div>
            
            <UserMenu collapsed={isSidebarCollapsed} />
        </div>
    );
};

export default Sidebar;

